// @generated by protoc-gen-es v1.6.0 with parameter "target=js"
// @generated from file dymensionxyz/dymension/iro/tx.proto (package dymensionxyz.dymension.iro, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { Duration, proto3, Timestamp } from "@bufbuild/protobuf";
import { BondingCurve, IncentivePlanParams, Params } from "./iro_pb";

/**
 * MsgUpdateParams allows to update module params.
 *
 * @generated from message dymensionxyz.dymension.iro.MsgUpdateParams
 */
export const MsgUpdateParams = proto3.makeMessageType(
  "dymensionxyz.dymension.iro.MsgUpdateParams",
  () => [
    { no: 1, name: "authority", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "new_params", kind: "message", T: Params },
  ],
);

/**
 * @generated from message dymensionxyz.dymension.iro.MsgUpdateParamsResponse
 */
export const MsgUpdateParamsResponse = proto3.makeMessageType(
  "dymensionxyz.dymension.iro.MsgUpdateParamsResponse",
  [],
);

/**
 * MsgCreatePlan defines a message to create a new plan.
 *
 * @generated from message dymensionxyz.dymension.iro.MsgCreatePlan
 */
export const MsgCreatePlan = proto3.makeMessageType(
  "dymensionxyz.dymension.iro.MsgCreatePlan",
  () => [
    { no: 1, name: "owner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "rollapp_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "allocated_amount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "bonding_curve", kind: "message", T: BondingCurve },
    { no: 5, name: "start_time", kind: "message", T: Timestamp },
    { no: 6, name: "iro_plan_duration", kind: "message", T: Duration },
    { no: 7, name: "incentive_plan_params", kind: "message", T: IncentivePlanParams },
  ],
);

/**
 * @generated from message dymensionxyz.dymension.iro.MsgCreatePlanResponse
 */
export const MsgCreatePlanResponse = proto3.makeMessageType(
  "dymensionxyz.dymension.iro.MsgCreatePlanResponse",
  () => [
    { no: 1, name: "plan_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * MsgBuy defines a message to buy allocation.
 *
 * @generated from message dymensionxyz.dymension.iro.MsgBuy
 */
export const MsgBuy = proto3.makeMessageType(
  "dymensionxyz.dymension.iro.MsgBuy",
  () => [
    { no: 1, name: "buyer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "plan_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "amount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "max_cost_amount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message dymensionxyz.dymension.iro.MsgBuyExactSpend
 */
export const MsgBuyExactSpend = proto3.makeMessageType(
  "dymensionxyz.dymension.iro.MsgBuyExactSpend",
  () => [
    { no: 1, name: "buyer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "plan_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "spend", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "min_out_tokens_amount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message dymensionxyz.dymension.iro.MsgBuyResponse
 */
export const MsgBuyResponse = proto3.makeMessageType(
  "dymensionxyz.dymension.iro.MsgBuyResponse",
  [],
);

/**
 * MsgSell defines a message to sell allocation.
 *
 * @generated from message dymensionxyz.dymension.iro.MsgSell
 */
export const MsgSell = proto3.makeMessageType(
  "dymensionxyz.dymension.iro.MsgSell",
  () => [
    { no: 1, name: "seller", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "plan_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "amount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "min_income_amount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message dymensionxyz.dymension.iro.MsgSellResponse
 */
export const MsgSellResponse = proto3.makeMessageType(
  "dymensionxyz.dymension.iro.MsgSellResponse",
  [],
);

/**
 * MsgClaim defines a message to claim tokens after the plan is settled.
 *
 * @generated from message dymensionxyz.dymension.iro.MsgClaim
 */
export const MsgClaim = proto3.makeMessageType(
  "dymensionxyz.dymension.iro.MsgClaim",
  () => [
    { no: 1, name: "claimer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "plan_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message dymensionxyz.dymension.iro.MsgClaimResponse
 */
export const MsgClaimResponse = proto3.makeMessageType(
  "dymensionxyz.dymension.iro.MsgClaimResponse",
  [],
);

